const ROOT = "/society-survey";

const societySurveyPaths = {
  root: ROOT,
};

export default societySurveyPaths;
